module.exports = __webpack_public_path__ + "static/media/lobby.f3e3c763.jpg";